
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ad-dashboard-outstream',
	templateUrl: './ad-dashboard-outstream.component.html',
	styleUrls: ['./ad-dashboard-outstream.component.scss']
})

export class AdDashboardOutstreamComponent implements OnInit {

	ngOnInit(): void {
		//
	}
}
